import React, { useState, useEffect } from "react";
// Chakra imports
import {
  VStack,
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon,
  IconButton,
} from "@chakra-ui/react";
import { FaPencilAlt, FaWallet, FaCircleNotch } from "react-icons/fa";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import useGetCashes from "../../hooks/useGetCashes";
import CreateCash from "../../modals/CreateCash";
import EditCash from "../../modals/EditCash";
import Pagination from "./Pagination";
import CreateUsage from "../../modals/CreateUsage";



function CashesTable({
  reloadTotal,
}) { 
    const [ page, setPage ] = useState(1); 
    const pageLimit = 12;
    let { 
      cashes, 
      totalCashes,
      setGettingCashes, 
      gettingCashes, 
      gettingCashesReqSuccess 
    } = useGetCashes({ page, limit: pageLimit, isToolsClerk: true });
    const { isOpen: isOpenCreate, onOpen: onOpenCreate, onClose: onCloseCreate } = useDisclosure();
    const { isOpen: isOpenEdit, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
    const [ toEditUser, setToEditUser ] = useState(null);
    
    const { isOpen: isOpenCreateUsage, onOpen: onOpenCreateUsage, onClose: onCloseCreateUsage } = useDisclosure();
    const [ toCreateUsage, setToCreateUsage ] = useState(null);
  
    useEffect(() => {
      setGettingCashes(true);
    }, [page]);
  
    useEffect(() => {
      // console.log(cashes);
    }, [cashes]);
  
    const reloadPage = () => {
      setGettingCashes(true);
      if (reloadTotal) {
        reloadTotal();
      }
    }
  
    const selectEditItem = (id) => {
      // console.log(id);
      const user = cashes.find((c) => c.id === id);
      // console.log(user.email);
      setToEditUser(user);
      onOpenEdit(true);
    }

    const selectCreateUsage = (id) => {
      setToCreateUsage(id);
      onOpenCreateUsage(true);
    }
  
    const textColor = useColorModeValue("gray.700", "white");

    return (
        <Card overflowX={{ sm: "scroll", xl: "hidden" }}>

          <CardHeader p="6px 0px 22px 0px">
              <Flex w="100%"
              flexDirection={{
                  sm: "row",
                  md: "row",
              }}
              alignItems={{ xl: "center" }}>
              <Box>
                  <Text fontSize="lg" color={textColor} fontWeight="bold" pb=".5rem">
                  Petty Cash
                    <IconButton 
                      ml="8px"
                      onClick={reloadPage}
                      title="Reload Data"
                      icon={<Icon as={FaCircleNotch} me="4px" />} 
                    />
                  </Text>
              </Box>
              <Spacer />
              <Box>
                  <Button colorScheme="teal" mr="4" onClick={onOpenCreate}>
                  Create New
                  </Button>
              </Box>
              </Flex>
          </CardHeader>
          <CardBody>
              <Flex direction="column" w="100%">
              <Table variant="simple" color={textColor}>
                  <Thead>
                  <Tr my=".8rem" pl="0px" color="gray.400">
                      <Th pl="0px" color="gray.400">Amount</Th>
                      <Th pl="0px" color="gray.400">Purpose</Th>
                      <Th pl="0px" color="gray.400">Added Date</Th>
                      <Th pl="0px" color="gray.400">Actions</Th>
                  </Tr>
                  </Thead>
                  <Tbody>
                  {gettingCashes ? 
                      <Tr my=".8rem" >
                      <Td minWidth={{ sm: "250px" }} pl="0px" colSpan={4}>
                          <Progress isIndeterminate />
                      </Td>
                      </Tr>
                      : cashes.map((cash) => {
                      return (
                          <Tr my=".8rem" pl="0px">
                            <Td pl="0px">
                              ₱{Number(cash.amount).toLocaleString()}
                            </Td>
                            <Td pl="0px">
                                {cash.purpose}
                            </Td>
                            <Td  pl="0px">
                                {new Date(cash.createdAt).toLocaleString()}
                            </Td>
                            <Td  pl="0px">
                                <Button p="0px" bg="transparent" onClick={() => selectEditItem(cash.id)}>
                                <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                    <Icon as={FaPencilAlt} me="4px" />
                                    <Text fontSize="xs" fontWeight="semibold">
                                    EDIT
                                    </Text>
                                </Flex>
                                </Button>

                                <Button p="0px" bg="transparent" 
                                  onClick={() => selectCreateUsage(cash.id)}>
                                <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                    <Icon as={FaWallet} me="4px" />
                                    <Text fontSize="xs" fontWeight="semibold">
                                    DISBURSE
                                    </Text>
                                </Flex>
                                </Button>
                            </Td>
                          </Tr>
                      );
                      })
                  }
                  </Tbody>
              </Table>
              <Pagination 
                  totalItems={totalCashes}
                  pageRows={pageLimit}
                  currentPage={page}
                  onPageChanged={setPage}
              />
              </Flex>


              
          </CardBody>


          <CreateCash 
            isOpen={isOpenCreate}
            onClose={onCloseCreate}
            successCallback={reloadPage} 
            isToolsClerk={true}
          />
       
                 
          <EditCash 
            isOpen={isOpenEdit}
            onClose={() => {
              setToEditUser(null);
              onCloseEdit();
            }}
            successCallback={reloadPage}
            userData={toEditUser}
            isToolsClerk={true}
          /> 



          <CreateUsage 
            isOpen={isOpenCreateUsage}
            onClose={onCloseCreateUsage}
            successCallback={reloadPage} 
            cashId={toCreateUsage}
          />
      </Card>
      );
}


export default CashesTable;
